export default __webpack_public_path__ + "static/media/built_in_icons.78e85045.png";